import { ColumnDefinitions, ColumnGroup } from './column-group.class';
import { TranslationsService } from '../services/translations.service';
import { Injectable } from '@angular/core';
import { FilterChangedEvent } from 'ag-grid-community';
import {
  companyPointsCssClass,
  compareVrmRatingToColleagues,
  convertCompanyPointsScoreToRating,
  convertRatingScoreToRatingText,
  getAgGridTextClassForScore,
  sortHighMediumLowRatings,
} from '../helpers/driver.helpers';
import { CommonService } from '../services/common.service';
import { noPositiveYesNegativeCssClass } from '../helpers/data.helpers';
import { booleanDataMap } from '../data/data-maps/generic.data';
import { calculateAverage, calculateStandardDeviation } from '../helpers/maths';
import { indexingRatingDataMap } from '../data/data-maps/drivers.data-map';

@Injectable({ providedIn: 'root' })
export class DriverColumns extends ColumnGroup {
  public constructor(private translations: TranslationsService, private commonService: CommonService) {
    super();
  }

  protected columnDefinitions: ColumnDefinitions = {
    indexingRating: () => ({
      width: 120,
      refData: this.translations.translateDataMap(indexingRatingDataMap),
      cellClass: (params) => getAgGridTextClassForScore(params.data.indexingRating),
    }),
    locationRating: () => {
      let standardDeviation = 0;
      let average = 0;

      return {
        width: 120,
        events: {
          filterChanged: (event: FilterChangedEvent) => {
            const allIndexingIndexValues = [];
            event.api.forEachNodeAfterFilter((node) => allIndexingIndexValues.push(node.data.indexingIndexValue));

            standardDeviation = calculateStandardDeviation(allIndexingIndexValues);
            average = calculateAverage(allIndexingIndexValues);

            event.api.refreshCells({ columns: ['locationRating'] });
          },
        },
        valueFormatter: (params) => {
          const rating = convertRatingScoreToRatingText(params.value);
          return this.translations.translate(`REPORTDATA.${rating}`, rating);
        },
        valueGetter: (params) => {
          return compareVrmRatingToColleagues(
            params.data.indexingIndexValue,
            params.data.indexingRating,
            standardDeviation,
            average
          );
        },
        cellClass: (params) => getAgGridTextClassForScore(params.api.getValue('locationRating', params.node)),
      };
    },
    companyPointsRating: {
      width: 140,
      filterValueGetter: (params) => {
        const riskLevels = this.commonService.userProfile.companyRiskLevelValues;
        const rating = convertCompanyPointsScoreToRating(params.data.companyPointsRating, riskLevels);
        return this.translations.translate(`REPORTDATA.${rating}`, rating);
      },
      valueFormatter: (params) => {
        const riskLevels = this.commonService.userProfile.companyRiskLevelValues;
        const rating = convertCompanyPointsScoreToRating(params.value, riskLevels);
        return this.translations.translate(`REPORTDATA.${rating}`, rating);
      },
      cellClass: (params) =>
        companyPointsCssClass(
          params.api.getValue('companyPointsRating', params.node),
          this.commonService.userProfile.companyRiskLevelValues
        ),
    },
    hasOutstandingActions: () => ({
      width: 180,
      refData: this.translations.translateDataMap(booleanDataMap),
      cellClass: (params) => noPositiveYesNegativeCssClass(params.api.getValue('hasOutstandingActions', params.node)),
    }),
  };
}
